import React, {useEffect, useRef, useState} from 'react';
import Select, {components} from 'react-select';
import './react-select.sass';
import {useField} from '@unform/core';
import useStore from '../../hooks/use-store';

const ReactSelectCustomer = (props) => {

    const {store} = useStore();
    const {azulPayStore, fullControlStore} = store;
    const ref = useRef(null);
    const [provider] = useState(props.provider || 'AZUL_PAY');

    const [customers, setCustomers] = useState([{id: 0, title: 'Novo Cliente'}]);

    const {
        name,
        label,
        options,
        onChange,
    } = props;

    const {
        fieldName,
        registerField,
        defaultValue,
        error,
    } = useField(name);

    useEffect(() => {
        const customers = [];
        if (provider === 'AZUL_PAY') {
            azulPayStore.getCustomers().map((customer) => {
                customers.push({id: customer.id, title: customer.full_name});
            });
        }
        if (provider === 'FULL_CONTROL') {
            fullControlStore.getClients().map((customer) => {
                customers.push({id: customer.id, title: customer.nome});
            });
        }
        setCustomers(customers);

    }, [provider]);

    useEffect(() => {

        registerField({
            name: fieldName,
            ref: ref.current,
            path: 'state.value',
            parseValue: parseSelectValue,
            clearValue: (selectRef) => {
                selectRef.select.clearValue();
            },
        });
    }, [ref.current, fieldName]);

    const parseSelectValue = (selectValue) => {
        return selectValue ? selectValue.id : '';
    };

    const getDefaultValue = () => {
        if (!defaultValue) return null;

        return customers.find((option) => option.id === defaultValue);
    };

    const DropdownIndicator = (props) => {
        return (
            <components.DropdownIndicator {...props}>
                <span className="far fa-chevron-down" style={{color: 'black'}}/>
            </components.DropdownIndicator>
        );
    };

    const IndicatorSeparator = () => null;

    const Control = (props) => (
        <components.Control
            {...props}
            className="custom-shadow rounded-pill px-2"
        />
    );

    return (
        <>
            {label && <label htmlFor={fieldName}>{label}</label>}

            <Select
                name={fieldName}
                aria-label={fieldName}
                options={customers}
                isMulti={false}
                defaultValue={getDefaultValue()}
                ref={ref}
                onChange={onChange}
                getOptionValue={(option) => option.id}
                getOptionLabel={(option) => option.title}
                components={{
                    DropdownIndicator,
                    IndicatorSeparator,
                    Control
                }}
                {...props}
            />

            {error && <span className="error">{error}</span>}
        </>
    );
};

export default ReactSelectCustomer;
